var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "custom-itl__img",
    viewBox: "0 0 28 28"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#001138",
    d: "M21.62 10a2 2 0 0 0-1.4-1.46A44.6 44.6 0 0 0 14 8.15a46 46 0 0 0-6.25.35A2.06 2.06 0 0 0 6.31 10 23 23 0 0 0 6 14a22.6 22.6 0 0 0 .33 4 2 2 0 0 0 1.4 1.46 46 46 0 0 0 6.25.35 47 47 0 0 0 6.26-.34A2 2 0 0 0 21.62 18a22.7 22.7 0 0 0 .38-4 21 21 0 0 0-.33-4Zm-9.25 6.48v-5L16.53 14Z"
  })));
};
export default SvgYoutube;